import styled, { css } from 'styled-components';

interface ContainerProps {
  isFilled: boolean;
  isFocuses: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: transparent;
  border-radius: 10px;
  border: 1.5px solid #3e3e3e;
  padding: 5px 10px;
  width: 100%;
  display: flex;
  align-items: center;

  + div {
    margin-top: 8px;
  }

  textarea {
    flex: 1;
    background: transparent;
    border: 0;
    color: #f4ede8;
    transition-duration: 0.2s;

    ::placeholder {
      color: #666360;
    }
  }

  svg {
    margin-right: 16px;
    color: #666360;
    transition-duration: 0.2s;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      svg {
        color: #6e6e6e;
      }
    `}

  ${(props) =>
    props.isFocuses &&
    css`
      color: #6e6e6e;
      border-color: #6e6e6e;

      svg {
        color: #6e6e6e;
      }
    `}
`;
